import { Container} from "@material-ui/core";
import { Home } from "./components/Home/Home";
import { Navbar } from "./components/Navbar/Navbar";
import {Auth}  from "./components/Auth/Auth"
import {BrowserRouter,Route,Routes} from 'react-router-dom'
import React from "react";
import { Profile } from "./components/Profile/Profile";
import Form from './components/Form/Form';
import { Modal } from "./components/Modal/Modal";


const App=()=>{
   
    return(
        <BrowserRouter>
            <Container maxWidth="lg">
                <Navbar/>
                    <Routes>
                    <Route path="/" element={<Home />}/>
                    <Route path="/auth" element={<Auth/>}/>
                    <Route path='/Profile?uid' element={<Profile/>}/>  
                    <Route path="/Form" element={<Form/>}/>       
                    <Route path="/modal" element={<Modal/>}/>       
                    </Routes>
            </Container>
        </BrowserRouter>
        // <Userlist/>
    )
}

export default App;